const changeSearchEntry = (searchEntry) => ({
  type: 'FIELD_PATHS_CHANGE_SEARCH_ENTRY',
  searchEntry,
});

export default changeSearchEntry;
